import { SearchSettingRepository } from '../../domain/repositories/SearchSettingRepository'
import { SearchSettingModel } from '../models/SearchSettingModel'
import type { CreateUpdateSearchSettingEntity } from '../../domain/entities/CreateUpdateSearchSettingEntity'
import { CreateUpdateSearchSettingModel } from '../models/CreateUpdateSearchSettingModel'
import type { SearchSettingEntity } from '../../domain/entities/SearchSettingEntity'
import { SearchSettingsService, type PostPutSearchSettingRequestAdmin } from '@/backend/market'

export class SearchSettingRepositoryImpl implements SearchSettingRepository {
  async getSearchSettings(serviceId: number): Promise<SearchSettingEntity | { error: true }> {
    try {
      const response = await SearchSettingsService.getSearchSettingAdmin({
        serviceId
      })
      const searchServiceModel = new SearchSettingModel(response)

      return searchServiceModel
    } catch {
      return { error: true }
    }
  }
  async createSearchSettings(
    serviceId: number,
    settingData: CreateUpdateSearchSettingEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateSearchSettingModel = new CreateUpdateSearchSettingModel(settingData)
    try {
      await SearchSettingsService.postSearchSettingByServiceIdAdmin({
        serviceId,
        requestBody: createUpdateSearchSettingModel as PostPutSearchSettingRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteSearchSettings(serviceId: number): Promise<{ success: true } | { error: true }> {
    try {
      await SearchSettingsService.deleteSearchSettingAdmin({
        serviceId
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
